import React, { memo, useEffect } from 'react';
import propTypes from 'prop-types';
import TimeoutIcon from '../../../resources/images/time_out.svg';
import Button from '../../global/atoms/button';
import GlobalModal from '../../global/atoms/globalModal/GlobalModal';
import { getEmailVerificationObject } from '../../guidedReg/utils/guidedUtil';
import { useAnalyticsContext } from '../../../config/GoogleTagManagerEvents';
import { EVENT_ECOMMERCE_NAMES_CONFIG } from '../../../constants/analyticsConstants/Ecommerce';
import { VerificationTimeOutTestId } from '../GRTestId';
import './VerificationTimoutModal.scss';

const VerificationTimoutModal = ({ timeoutModal, hideTimeoutModal, resendCode }) => {
    const emailTokens = getEmailVerificationObject();
    const {
        resendCodeButtonLabel = '',
        verificationTimeoutTitle = '',
        verificationTimeoutDescription = ''
    } = emailTokens || {};

    const { sendEventsForGRModalOpened, sendEventsForGRModalCompleted } = useAnalyticsContext();

    useEffect(() => {
        if (timeoutModal) {
            sendEventsForGRModalOpened(
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_FORM_VIEWED,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_MODAL_VERIFICATION_TIMEOUT,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_INFORMATION,
                ''
            );
        }
    }, []);

    const handleResendCode = () => {
        hideTimeoutModal();
        resendCode();
        sendEventsForGRModalCompleted(
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_FORM_COMPLETED,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_MODAL_VERIFICATION_TIMEOUT,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_INFORMATION,
            resendCodeButtonLabel
        );
    };

    const emailTokenTitle = () => {
        return (
            <>
                <TimeoutIcon tabIndex={'-1'} aria-hidden={true} />
                <span>{verificationTimeoutTitle}</span>
            </>
        );
    };

    const emailTokenContent = () => {
        return (
            <>
                <span data-testid={VerificationTimeOutTestId.MODAL_DESCRIPTION}>{verificationTimeoutDescription}</span>
                <div className="helpmodal__actions">
                    {resendCodeButtonLabel && (
                        <Button
                            data-testid={VerificationTimeOutTestId.RESEND_BUTTON}
                            tabIndex={0}
                            buttonAriaLabel={resendCodeButtonLabel}
                            className={`button button-primary button-block`}
                            onClick={handleResendCode}>
                            {resendCodeButtonLabel}
                        </Button>
                    )}
                </div>
            </>
        );
    };

    return (
        <>
            <GlobalModal
                titleClasses={'email-timeout_title'}
                className={'width-327'}
                isOpen={timeoutModal}
                onRequestClose={hideTimeoutModal}
                title={emailTokenTitle()}
                content={emailTokenContent()}
                handleClose={hideTimeoutModal}
            />
        </>
    );
};

export default memo(VerificationTimoutModal);

VerificationTimoutModal.propTypes = {
    timeoutModal: propTypes.bool,
    hideTimeoutModal: propTypes.func
};
